<template>
  <div>
    <div v-if="isAuthenticated">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            id="edit-tab"
            data-toggle="tab"
            href="#edit"
            role="tab"
            aria-controls="edit"
            aria-selected="true"
            >Edit Account</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="address-tab"
            data-toggle="tab"
            href="#address"
            role="tab"
            aria-controls="address"
            aria-selected="false"
            >Edit Address</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="preferences-tab"
            data-toggle="tab"
            href="#preferences"
            role="tab"
            aria-controls="preferences"
            aria-selected="false"
            >Preferences</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="data-tab"
            data-toggle="tab"
            href="#data"
            role="tab"
            aria-controls="data"
            aria-selected="false"
            >My Data</a
          >
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div
          class="tab-pane fade show active"
          id="edit"
          role="tabpanel"
          aria-labelledby="edit-tab"
        >
          <div class="embed-responsive embed-responsive-4by3">
            <iframe
              loading="lazy"
              class="embed-responsive-item"
              src="/my-account-edit?iframemode=true"
              allowfullscreen
            ></iframe>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="address"
          role="tabpanel"
          aria-labelledby="address-tab"
        >
          <div class="embed-responsive embed-responsive-4by3">
            <iframe
              loading="lazy"
              class="embed-responsive-item"
              src="/my-account-address?iframemode=true"
              allowfullscreen
            ></iframe>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="preferences"
          role="tabpanel"
          aria-labelledby="preferences-tab"
        >
          <div class="embed-responsive embed-responsive-4by3">
            <iframe
              loading="lazy"
              class="embed-responsive-item"
              src="/preferences?iframemode=true"
              allowfullscreen
            ></iframe>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="data"
          role="tabpanel"
          aria-labelledby="data-tab"
        >
          <div
            class="embed-responsive embed-responsive-4by3"
            style="position: relative"
          >
            <div v-if="showDataSpinner" class="iframe-spinner">
              <img src="/images/download-spinner.gif" alt="Loading..." />
            </div>
            <iframe
              id="myData"
              loading="lazy"
              class="embed-responsive-item"
              src="/my-data?iframemode=true"
              allowfullscreen
              @load="showDataSpinner = false"
            ></iframe>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!isAuthenticated">Please Login first.</div>
  </div>
</template>

<script>
import Vue from "vue";
import { playerService } from "../player-service";

export default Vue.component("update-account-preferences", {
  data: function () {
    return {
      isAuthenticated: !window.authenticatedUserEmail == false,
      showDataSpinner: true,
    };
  },

  mounted: function () {
    playerService.$on("user-updated", () => {
      this.isAuthenticated = !window.authenticatedUserEmail == false;
    });

    // Change the download modal contents depending on whats passed to it.
    playerService.$on("open-update-account-preferences", () => {
      // Open the modal.
      window.webpackOpenBsModalWorkaround("#updateAccountPreferences");

      document.getElementById("myData").contentWindow.location.reload();
    });

    window
      .$("#updateAccountPreferences")
      .on("hidden.bs.modal", function () {
        $(this)
          .find("iframe")
          .each(function () {
            var iframe = this;
            try {
              var alerts = iframe.contentDocument.querySelectorAll("div.alert:not(.alert-important)");
              alerts.forEach(function (alert) {
                alert.remove();
              });
            } catch (e) {
              /* cross-origin iframe — nothing to do */
            }
          });
      });

    const self = this;
    if (window.$) {
      $("#data-tab").on("shown.bs.tab", function () {
        self.showDataSpinner = true;
      });
    }
  },
});
</script>

<style>
.iframe-spinner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
